import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {localidadesModuleName, localidadesStorage} from "../shared/data.service";
import {Localidade} from "../shared/localidade.model";
import {Endereco} from "../../enderecos/shared/endereco.model";
import { editRoute, newRouteFemale } from "../../../shared/services/data.service";
import {LocalidadeNavigationService} from "../shared/localidade-navigation.service";
import {LocalidadeApiService} from "../shared/localidade-api.service";
import {LocalidadeService} from "../shared/localidade.service";
import {EnderecoApiService} from "../../enderecos/shared/endereco-api.service";
import {UtilService} from "../../../shared/services/util.service";
import {EnderecoService} from "../../enderecos/shared/endereco.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {TipoLocalidade} from "../localidades-tipos/localidade-tipos.model";
import {LocalidadeTiposApiService} from "../localidades-tipos/localidade-tipos-api.service";

@Component({
    template: require('./localidade-form.component.html'),
    styles: [require('./localidade-form.component.css')]
})
export class LocalidadeFormComponent implements OnInit {
    localidadesModule: any = localidadesModuleName;
    formObject: any = new Localidade();
    tipoLocalidadeObject: any = new TipoLocalidade();
    formObjectToSave: any = new Localidade();
    enderecoObject: any = new Endereco();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    showAddress: boolean = false;

    tiposLocalidadesList: TipoLocalidade[] =[];

    form: FormGroup;
    ativo = new FormControl('');
    localidade = new FormControl('', Validators.required);
    codigoUnidadeOrcamentaria = new FormControl('');
    tipoLocalidade = new FormControl('');

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseLocalidade: any;

    constructor(
        private _route: ActivatedRoute,
        private _localidadeNavigationService: LocalidadeNavigationService,
        private _localidadeApiService: LocalidadeApiService,
        private _localidadeService: LocalidadeService,
        private _enderecoApiService: EnderecoApiService,
        private _enderecoService: EnderecoService,
        private _localidadeTiposApiService: LocalidadeTiposApiService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            localidade: this.localidade,
            codigoUnidadeOrcamentaria: this.codigoUnidadeOrcamentaria,
            tipoLocalidade: this.tipoLocalidade
        });
    }

    ngOnInit() {
        this.getTiposLocalidade();
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:Localidade = this._utilService.cloneObject(this.formObject);

            if (this.tipoLocalidadeObject.id) {
                object.tipoLocalidadeId = this.tipoLocalidadeObject.id;
            } else {
                object.tipoLocalidadeId  = null;
            }

            this.formObjectToSave = object;
            this._enderecoService.onSubmit(this.enderecoObject, this.onDoneEndereco);
        }
    }

    private onDoneEndereco = (function (Response: any) {
        if (!Response.error)  {
            var addressId: number = Response.id;
            this.formObjectToSave.enderecoId = addressId;
            if (this.formObject.id) {
                this.onEditLocalidade();
            } else {
                this.onAddLocalidade();
            }
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private onAddLocalidade() {
        this._localidadeApiService.onPost(this.formObjectToSave, this.onDone);
    }

    private onEditLocalidade() {
        this._localidadeApiService.onPut(this.formObjectToSave, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseLocalidade = Response;

            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma localidade encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._localidadeApiService.onGetById(id, onDone);
    }

    private testSession() {
        var id: number;
        var session: any = this._localidadeService.getSessionStorage();
        this._localidadeService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {
        if (this.formObject.tipoLocalidade) {
            this.tipoLocalidadeObject = this.formObject.tipoLocalidade;
            delete this.formObject['tipoLocalidade'];

            if (this.tiposLocalidadesList.length) {
                this.setTipoLocalidade();
            }
        }

        if (this.formObject.endereco) {
            this.enderecoObject = this.formObject.endereco;
            delete this.formObject['endereco'];
        }

        this.showAddress = true;
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._localidadeService.returnToOtherForm(this.otherForm, this.responseLocalidade);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._localidadeNavigationService.goToList();
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(localidadesStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.localidade = newAutoComplete.localidade;

            this.setActionTitle(this.formObject.id);
            this.showAddress = true;
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRouteFemale;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        this.showAddress = true;
        //se tiver alguma configuração inicial de um cadastro novo
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    private getTiposLocalidade() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.tiposLocalidadesList = Response;
                this.tiposLocalidadesList.unshift({id: null, tipo: '— Selecione —'});
                this.setTipoLocalidade();
            }
        }.bind(this));

        this._localidadeTiposApiService.onGetAll(onDone);
    }

    private setTipoLocalidade() {
        var x: any, lenX: any,
            t: number = this.tipoLocalidadeObject.id;

        if (!t) {
            t = this.tiposLocalidadesList[0].id;
        }

        for (x = 0, lenX = this.tiposLocalidadesList.length; x < lenX; x++) {
            if (this.tiposLocalidadesList[x].id === t) {
                this.tipoLocalidadeObject = this.tiposLocalidadesList[x];
                break;
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/localidade-form/localidade-form.component.ts
 **/